import 'twin.macro';

const ContainerSections = ({ children, otherStyles, style }) => {
  return (
    <div
      tw="xl:ml-[5%] xl:mr-32 rounded-[50px] lg:mx-5 mx-0"
      css={otherStyles}
      style={style}
      className="container-sections"
    >
      {children}
    </div>
  );
};
export default ContainerSections;
